import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 60,
      width: 60,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bottom: theme.spacing(3),
      right: theme.spacing(3),
      padding: theme.spacing(2),
      overflow: 'hidden',
      cursor: 'pointer',
      zIndex: 10,
      transition: theme.transitions.create(
        ['opacity', 'width', 'height', 'border-radius'],
        {
          duration: theme.transitions.duration.standard,
          easing: theme.transitions.easing.easeInOut,
        },
      ),

      '&:hover': {
        opacity: 0.8,
      },
    },
    open: {
      width: 200,
      height: 230,
      borderRadius: theme.shape.borderRadius,
    },
    icon: {
      fontSize: theme.typography.pxToRem(40),
      color: theme.palette.common.white,
      transform: 'translateX(8.5px)',
    },
    infoContainer: {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: '100%',
      padding: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
  }),
);
